/**
 * RETOBLOCK PYTHON WORKSPACE & CODE EDITOR
 * Trình biên soạn mã nguồn Python chuẩn Dark Mode tích hợp đánh số dòng và snippets nhanh.
 */

export class PythonEditor {
  constructor(options) {
    this.container = options.container;
    this.projectManager = options.projectManager;
    this.onCodeChange = options.onCodeChange;
    this.errorLine = null;

    this.init();
  }

  init() {
    const defaultCode = this.projectManager.getPythonCode() || `# ==============================================================================
# RETOLOGIX STUDIO - PYTHON CODE
# Target Kit: RETOCAR-STARTER (ESP32)
# ==============================================================================
from retologix import RetoCar
import time

robot = RetoCar()

try:
    print("Robot RETOCAR-STARTER san sang khoi hanh!")
    robot.set_rgb_color("BLUE")
    robot.buzzer_tone(1500)
    time.sleep(0.1)
    robot.buzzer_off()

    # Cho xe tiến 1 giây rồi dừng
    robot.move(direction="FORWARD", speed=60)
    time.sleep(1.0)
    robot.stop()

except KeyboardInterrupt:
    robot.stop()
    robot.buzzer_off()
`;

    this.container.innerHTML = `
      <div class="python-workspace">
        <!-- Top Tab Bar -->
        <div class="editor-tab-bar">
          <div class="editor-tabs">
            <div class="editor-tab">
              <span class="python-file-icon">🐍</span>
              <span>main.py</span>
            </div>
          </div>

          <div class="editor-actions">
            <button class="btn-editor-action" id="btn-format-code" title="Tự động căn chỉnh mã nguồn">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="21" x2="3" y1="6" y2="6"/><line x1="15" x2="3" y1="12" y2="12"/><line x1="17" x2="3" y1="18" y2="18"/></svg>
              <span>Định dạng mã (Format)</span>
            </button>
          </div>
        </div>

        <!-- Editor Main Area -->
        <div class="editor-main">
          <div class="line-numbers-col" id="editor-line-numbers"></div>
          <div class="code-area-wrapper">
            <textarea class="code-textarea" id="python-textarea" spellcheck="false" placeholder="Soạn thảo mã Python tại đây...">${defaultCode}</textarea>
          </div>
        </div>

        <!-- Quick Snippets Bar -->
        <div class="snippets-bar">
          <span class="snippets-label">Mẫu lệnh nhanh:</span>
          <button class="snippet-chip" data-snippet="robot.move(direction='FORWARD', speed=60)">move('FORWARD', 60)</button>
          <button class="snippet-chip" data-snippet="robot.stop()">robot.stop()</button>
          <button class="snippet-chip" data-snippet="robot.get_distance()">get_distance()</button>
          <button class="snippet-chip" data-snippet="robot.get_line(sensor=2)">get_line(2)</button>
          <button class="snippet-chip" data-snippet="robot.set_rgb_color('GREEN')">set_rgb('GREEN')</button>
          <button class="snippet-chip" data-snippet="robot.buzzer_tone(1500)">buzzer_tone(1500)</button>
          <button class="snippet-chip" data-snippet="robot.set_arm_angle(90)">set_arm_angle(90)</button>
          <button class="snippet-chip" data-snippet="time.sleep(0.5)">time.sleep(0.5)</button>
        </div>
      </div>
    `;

    this.bindEvents();
    this.updateLineNumbers();
  }

  bindEvents() {
    const textarea = document.getElementById('python-textarea');
    const lineNumbers = document.getElementById('editor-line-numbers');

    // Sync line numbers on scroll
    textarea.addEventListener('scroll', () => {
      lineNumbers.scrollTop = textarea.scrollTop;
    });

    // Handle input & tab key
    textarea.addEventListener('input', () => {
      this.clearErrorHighlight();
      this.updateLineNumbers();
      this.projectManager.updatePythonSource(textarea.value);
      if (this.onCodeChange) this.onCodeChange(textarea.value);
    });

    textarea.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        e.preventDefault();
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        textarea.value = textarea.value.substring(0, start) + '    ' + textarea.value.substring(end);
        textarea.selectionStart = textarea.selectionEnd = start + 4;
        this.clearErrorHighlight();
        this.updateLineNumbers();
        this.projectManager.updatePythonSource(textarea.value);
      } else if (e.key === 'Enter') {
        // Auto indentation
        const start = textarea.selectionStart;
        const currentLine = textarea.value.substring(0, start).split('\n').pop();
        const match = currentLine.match(/^\s*/);
        const indent = match ? match[0] : '';
        const extraIndent = currentLine.trim().endsWith(':') ? '    ' : '';

        setTimeout(() => {
          const newStart = start + 1;
          textarea.value = textarea.value.substring(0, start + 1) + indent + extraIndent + textarea.value.substring(start + 1);
          textarea.selectionStart = textarea.selectionEnd = newStart + indent.length + extraIndent.length;
          this.clearErrorHighlight();
          this.updateLineNumbers();
          this.projectManager.updatePythonSource(textarea.value);
        }, 0);
      }
    });

    // Snippets insertion
    document.querySelectorAll('.snippet-chip').forEach(chip => {
      chip.addEventListener('click', () => {
        const snippet = chip.getAttribute('data-snippet');
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        textarea.value = textarea.value.substring(0, start) + snippet + textarea.value.substring(end);
        textarea.selectionStart = textarea.selectionEnd = start + snippet.length;
        textarea.focus();
        this.clearErrorHighlight();
        this.updateLineNumbers();
        this.projectManager.updatePythonSource(textarea.value);
      });
    });

    // Format code button
    document.getElementById('btn-format-code').addEventListener('click', () => {
      this.formatCode();
    });
  }

  updateLineNumbers() {
    const textarea = document.getElementById('python-textarea');
    const lineNumbers = document.getElementById('editor-line-numbers');
    if (!textarea || !lineNumbers) return;

    const lines = textarea.value.split('\n').length;
    let numbersHtml = '';
    const totalLines = Math.max(lines, 20);
    for (let i = 1; i <= totalLines; i++) {
      const isError = this.errorLine === i;
      const errorClass = isError ? ' error-line-num' : '';
      numbersHtml += `<span class="line-num${errorClass}" data-line="${i}">${i}</span>`;
    }
    lineNumbers.innerHTML = numbersHtml;
  }

  highlightLine(lineNum) {
    if (!lineNum || lineNum < 1) return;
    this.errorLine = lineNum;
    this.updateLineNumbers();

    const textarea = document.getElementById('python-textarea');
    const lineNumbers = document.getElementById('editor-line-numbers');
    if (!textarea) return;

    const lines = textarea.value.split('\n');
    if (lineNum > lines.length) return;

    let startPos = 0;
    for (let i = 0; i < lineNum - 1; i++) {
      startPos += lines[i].length + 1; // +1 cho ký tự \n
    }
    const endPos = startPos + lines[lineNum - 1].length;

    textarea.focus();
    textarea.setSelectionRange(startPos, endPos);

    // Cuộn màn hình và cột số dòng đến dòng lỗi
    const lineHeight = 20;
    const targetScroll = Math.max(0, (lineNum - 1) * lineHeight - 60);
    textarea.scrollTop = targetScroll;
    if (lineNumbers) {
      lineNumbers.scrollTop = targetScroll;
    }
  }

  clearErrorHighlight() {
    if (this.errorLine !== null) {
      this.errorLine = null;
      this.updateLineNumbers();
    }
  }

  formatCode() {
    const textarea = document.getElementById('python-textarea');
    if (!textarea) return;
    const lines = textarea.value.split('\n');
    const trimmed = lines.map(line => line.trimEnd()).join('\n');
    textarea.value = trimmed;
    this.clearErrorHighlight();
    this.updateLineNumbers();
    this.projectManager.updatePythonSource(textarea.value);
  }

  setCode(code) {
    const textarea = document.getElementById('python-textarea');
    if (textarea) {
      textarea.value = code;
      this.clearErrorHighlight();
      this.updateLineNumbers();
    }
  }

  getCode() {
    const textarea = document.getElementById('python-textarea');
    return textarea ? textarea.value : '';
  }
}
